angular.module('MW.Framework.googleAnalyticsHighchart', [
    'MW.Framework.CoreCommon',
    'MW.InsDashboard.GoogleAnalyticsService',
    'MW.InsDashboard.GoogleAnalyticsErrorService',
    'MW.Framework.TranslationService'])
    .directive('googleAnalyticsHighchart', ['CoreCommon', '$timeout', '$q', 'GoogleAnalyticsService', 'GoogleAnalyticsErrorService', 'translationService', 'CoreUserService', function (CoreCommon, $timeout, $q, GoogleAnalyticsService, GoogleAnalyticsErrorService, translationService, CoreUserService) {
        'use strict';
        var currentChartId = 0;

        return {
            template: '<div class="googleAnalyticsHighchart" id="{{chartId}}"></div>',
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: {
                chartData: '=chartData',
                switcher: '&switcher'
            },
            link: function link(scope, element, attrs) {

                var chart,
                    chartTimeout = null,
                    xAxisLabelSelector = '.highcharts-xaxis-labels span';

                scope.requireChartRedraw = function requireChartRedraw(newValue, oldValue){
                    //If we don't have a chart, gotta draw one
                    if(!chart){
                        return true;
                    }
                    //If either value is not set, then we need to draw the initial chart
                    if(oldValue === null || typeof oldValue === 'undefined' || newValue === null || typeof newValue === 'undefined'){
                        return true;
                    }
                    //If the data sets don't match we need to redraw the chart
                    if(newValue.series.length !== oldValue.series.length){
                        return true;
                    }
                    //If the data sets don't match we need to redraw the chart
                    if(newValue.sessions !== oldValue.sessions){
                        return true;
                    }
                    //Redraw if chart is new type or has changed display modes
                    if(newValue.type !== oldValue.type || newValue.yAxis && oldValue.yAxis && newValue.yAxis.title.text !== oldValue.yAxis.title.text){
                        return true;
                    }
                    //If the chart types changed we need to start over
                    if(newValue.chart.type !== oldValue.chart.type){
                        return true;
                    }

                    return false;
                };

                // eslint-disable-next-line complexity
                scope.refreshChart = function refreshChart(newValue,oldValue) {
                    var newSettings,
                        i,
                        j;

                    if (!newValue || !newValue.series) {
                        return;
                    }

                    scope.$parent.widgetIsLoading = true;

                    if (scope.chartData.sessions && scope.chartData.sessions.error && scope.chartData.sessions.error.status === 504) {
                        scope.$parent.serviceError = true;
                    }

                    var hasFakeData = (scope.chartData.sessions && scope.chartData.sessions.fakeData);
                    var shouldHideTooltipOverride = false;

                    if (!scope.chartData.sessions) {
                        shouldHideTooltipOverride = true;
                    }
                    else if (scope.chartData.sessions.fakeData) {
                        shouldHideTooltipOverride = true;
                    }

                    var hasGoogleError = (scope.$parent.hasGoogleAccountError || scope.$parent.hasGooglePropertyError)
                    var hasSessionData = (scope.chartData.sessions && scope.chartData.sessions.otherSessionCount && scope.chartData.sessions.matchedSessionCount);

                    var chartDefaults = {
                        chart: {
                            animation: Highcharts.svg,
                            renderTo: scope.chartId
                        }
                    };

                    for(i = 0; i < scope.chartData.series.length; i++){
                        if(typeof scope.chartData.series[i].showInLegend == 'undefined' || scope.chartData.series[i].showInLegend === false){
                            for(j = 0; j < scope.chartData.series[i].data; j++){
                                if(scope.chartData.series[i].data[j].y === 0){
                                    scope.chartData.series[i].data[j].marker = {enabled:false};
                                }else{
                                    scope.chartData.series[i].data[j].marker = {enabled:true};
                                }
                            }
                        }
                    }

                    newSettings = CoreCommon.mergeRecursive(chartDefaults, scope.chartData);

                    var elementHeight;

                    if (scope.$parent.isMaximized) {
                        elementHeight = 400;
                    }
                    else {
                        elementHeight = element.parent().height() || null;
                    }

                    newSettings.chart = {
                        chartType:'xy',
                        height: elementHeight,
                        renderTo: scope.chartId,
                        type: 'spline'
                    };

                    if (hasFakeData || shouldHideTooltipOverride) {
                        newSettings.tooltip = {
                            enabled: false
                        };
                    } else {
                        newSettings.tooltip = {
                            shared: true
                        };
                    }

                    newSettings.legend = {
                        layout: 'horizontal',
                        align: 'center',
                        verticalAlign: 'bottom',
                        floating: false,
                        backgroundColor: (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#ffffff',
                        itemStyle: {
                            font: "11px \"Helvetica Neue\", Verdana, sans-serif",
                            fontWeight: "400"
                        }
                    };

                    newSettings.yAxis = [{ // Primary yAxis
                        gridLineColor: "#f2f2f2",
                        gridLineWidth: 1,
                        lineWidth: 1,
                        lineColor: "#f2f2f2",
                        tickLength: 5,
                        labels: {
                            format: '{value}',
                            style: {
                                color: '#ffad00',
                                font: "11px \"Helvetica Neue\", Verdana, sans-serif",
                                fontWeight: "400",
                                marginLeft: 0,
                                textOverflow: "none",
                                whiteSpace: "nowrap"
                            },
                            autoRotation: [-30],
                            x: -8
                        },
                        title: {
                            margin: 15,
                            text: translationService.getLocalizedString('google-analytics-widget__graph-yaxis--media-exposure'),
                            style: {
                                color: '#ffad00',
                                font: "12px \"Helvetica Neue\", Verdana, sans-serif",
                                fontWeight: "500"
                            }
                        },
                        tickColor: "#f2f2f2",
                        tickWidth: 1,
                        allowDecimals: false,
                        max: null,
                        minRange: 1,
                        min: 0
                    }];

                    newSettings.yAxis.push({ // Secondary yAxis
                        gridLineColor: "#f2f2f2",
                        gridLineWidth: 1,
                        lineWidth: 1,
                        lineColor: "#f2f2f2",
                        tickLength: 5,
                        title: {
                            margin: 15,
                            text: translationService.getLocalizedString('google-analytics-widget__graph-yaxis--sessions'),
                            style: {
                                color: '#3399ff',
                                font: "12px \"Helvetica Neue\", Verdana, sans-serif",
                                fontWeight: "500"
                            }
                        },
                        labels: {
                            format: '{value}',
                            style: {
                                color: '#3399ff',
                                font: "11px \"Helvetica Neue\", Verdana, sans-serif",
                                fontWeight: "400",
                                marginLeft: 0,
                                textOverflow: "none",
                                whiteSpace: "nowrap"
                            },
                            autoRotation: [-30],
                            x: 8
                        },
                        tickColor: "#f2f2f2",
                        tickWidth: 1,
                        allowDecimals: false,
                        max: null,
                        minRange: 1,
                        min: 0,
                        opposite: true
                    });

                    var seriesMediaExposure = newSettings.series[0];

                    newSettings.series = [{
                        color: '#ffad00',
                        data: seriesMediaExposure.data,
                        marker: {
                            lineWidth: 2,
                            lineColor: '#ffad00',
                            fillColor: 'white',
                            radius: 3.5
                        },
                        name: seriesMediaExposure.name,
                        type: 'spline',
                        yAxis: 0,
                        zIndex: '4'
                    }];

                    if(hasFakeData || hasGoogleError) {
                        if(!scope.chartData.sessions) {
                            scope.chartData.sessions = {
                                noData: []
                            }
                        } else {
                            scope.chartData.sessions.noData = []
                        }

                        for (var x = 0; x < seriesMediaExposure.data.length; x++) {
                            scope.chartData.sessions.noData.push(Math.round((Math.random() * 100)));
                        }

                        scope.$parent.googleError = GoogleAnalyticsErrorService.getError(scope.$parent.hasGoogleAccountError, scope.$parent.hasGooglePropertyError)

                        newSettings.series.push({
                            color: '#dddddd',
                            data: scope.chartData.sessions.noData,
                            name: translationService.getLocalizedString('google-analytics-widget__graph-legend-label--no-data'),
                            type: 'column',
                            yAxis: 1,
                            zIndex: '1'
                        });
                    } else if(hasSessionData) {
                        scope.$parent.hasGoogleAccountError = false;
                        scope.$parent.hasGooglePropertyError = false;
                        scope.$parent.googleError = GoogleAnalyticsErrorService.getError(scope.$parent.hasGoogleAccountError, scope.$parent.hasGooglePropertyError);

                        if (Array.isArray(scope.chartData.sessions.otherSessionCount) && scope.chartData.sessions.otherSessionCount.length > 0) {
                            newSettings.series.push({
                                color: '#99ccff',
                                data: scope.chartData.sessions.otherSessionCount,
                                name: translationService.getLocalizedString('google-analytics-widget__graph-legend-label--other-sessions'),
                                type: 'column',
                                yAxis: 1,
                                zIndex: '2'
                            });
                        }

                        newSettings.series.push({
                            color: '#3399ff',
                            data: scope.chartData.sessions.otherReferredSessionCount,
                            name: translationService.getLocalizedString('google-analytics-widget__graph-legend-label--referral-sessions'),
                            type: 'column',
                            yAxis: 1,
                            zIndex: '3'
                        });

                        newSettings.series.push({
                            color: '#033b7a',
                            data: scope.chartData.sessions.matchedSessionCount,
                            name: translationService.getLocalizedString('google-analytics-widget__graph-legend-label--earned-referral-sessions'),
                            type: 'column',
                            yAxis: 1,
                            zIndex: '1'
                        });
                    } else {
                        scope.$parent.googleError = GoogleAnalyticsErrorService.getError(scope.$parent.hasGoogleAccountError, scope.$parent.hasGooglePropertyError);
                    }

                    // set an arbitrary default so that we can avoid pulling the setting if it's not defined
                    var insaneLabelVisibilitySetting = 0;
                    if (scope.$parent.widget.settings.labelVisibility) {
                        insaneLabelVisibilitySetting = scope.$parent.widget.settings.labelVisibility[0].id;
                    }

                    var showLabels = (insaneLabelVisibilitySetting !== 1);
                    var hoverEnabled = true;
                    if (hasFakeData || shouldHideTooltipOverride) {
                        showLabels = false;
                        hoverEnabled = false;
                    }
                    var drilldownFn = function (event) {
                        var clickEvent = event || window.event;
                        var pointDate = scope.chartData.series[0].data[clickEvent.point.x].date;
                        var xPosition = clickEvent.point.x;

                        var googleTimezoneOverride = scope.$parent.widget.settings.timezoneOverride;
                        pointDate = moment(pointDate).tz(googleTimezoneOverride);

                        scope.$parent.internalDrillDown(null, pointDate, xPosition);
                    };

                    newSettings.plotOptions = {
                        series: {
                            states: {
                                hover: {
                                    enabled: hoverEnabled
                                }
                            }
                        },
                        column: {
                            cursor: 'pointer',
                            stacking: 'normal',
                            dataLabels: {
                                enabled: showLabels
                            },
                            events: {
                                click: drilldownFn
                            }
                        },
                        spline: {
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: showLabels
                            },
                            events: {
                                click: drilldownFn
                            }
                        }
                    };

                    if(chartTimeout !== null){
                        $timeout.cancel(chartTimeout);
                        chartTimeout = null;
                    }

                    //Check if chart needs to be redrawn
                    if(scope.requireChartRedraw(newValue, oldValue)) {
                        if(chart){
                            chart.destroy();
                        }
                        /**
                         * This timeout is needed to avoid drawing the chart before
                         * gridster has finished animating the widgets they are
                         * inside. (See GYDA-3721)
                         **/
                        chartTimeout = $timeout(function drawHighchart() {
                            if(!scope.$parent.isMaximized && hasGoogleError) {
                                var elemDiv = document.getElementsByClassName('googleErrorContainerMinView');

                                var defaultHeight = 0;
                                for (var elementCount=0; elementCount<elemDiv.length; elementCount++) {
                                    if (elemDiv[elementCount].offsetHeight > defaultHeight) {
                                        defaultHeight = elemDiv[elementCount].offsetHeight;
                                    }
                                }

                                newSettings.chart.height -= defaultHeight;
                            }

                            chart = new Highcharts.Chart(newSettings);

                            const thisChart = chart;
                            $('#' + scope.chartId).on('mouseenter', xAxisLabelSelector, function(e) {
                                var index = $(this).index();
                                thisChart.tooltip.refresh(chart.series[0].data[index]);
                                thisChart.series[0].data[index].setState('hover');
                            }).on('mouseleave', xAxisLabelSelector, function() {
                                thisChart.series[0].data[$(this).index()].setState();
                            });

                            $(xAxisLabelSelector).click(function (e) {
                                chart.series[0].data[$(this).index()].firePointEvent('click');
                            });

                            chartTimeout = null;
                        }, 450);
                    } else {
                        //Update the series containing data and disable points that don't yet have data
                        for(i = 0; i < newValue.series.length; i++){
                            if(typeof newValue.series[i].showInLegend == 'undefined' || newValue.series[i].showInLegend === false){
                                for(j = 0; j < newValue.series[i].data; j++){
                                    if(newValue.series[i].data[j].y === 0){
                                        newValue.series[i].data[j].marker = {enabled:false};
                                    }else{
                                        newValue.series[i].data[j].marker = {enabled:true};
                                    }
                                }
                                chart.series[i].setData(newValue.series[i].data);
                            }
                        }
                    }

                    if(seriesMediaExposure.data && (hasSessionData || hasFakeData || hasGoogleError)) {
                        scope.$parent.widgetIsLoading = false;
                    }
                };

                scope.chartId = 'googleAnalyticsHighchart' + (currentChartId++);

                scope.$watch(function chartDataWatcher() {
                        return scope.chartData;
                    },
                    function chartDataResponder(newValue, oldValue) {
                        scope.refreshChart(newValue,oldValue);
                    });

                scope.$on('widgetResized', function onChartResize() {
                    scope.refreshChart(scope.chartData);
                });

                scope.$on('widgetRedraw', function onChartResize() {
                    scope.refreshChart(scope.chartData);
                });

                scope.$on('$destroy', function onDestroyHighchart(){
                    angular.element(xAxisLabelSelector).off(); // drop all event handlers

                    if(chart){
                        chart.destroy();
                    }
                    if(chartTimeout !== null){
                        $timeout.cancel(chartTimeout);
                    }
                });
            }
        };
    }]);